import React from 'react';
import { List, ListItem, ListItemText, Typography } from '@mui/material';
import type { ApiErrorSection } from '@core/utils/apiErrors';
import Dialog from './Dialog';

export interface ErrorDialogProps {
  open: boolean;
  title?: string;
  sections: ApiErrorSection[];
  onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  open,
  title = 'Error details',
  sections,
  onClose,
}) => (
  <Dialog
    open={open}
    title={title}
    submitText="Close"
    onSubmitClick={onClose}
    onClose={onClose}
    hideCancel
    maxWidth="sm"
  >
    {sections.length === 0 ? (
      <Typography variant="body2" color="text.secondary">
        No additional details are available.
      </Typography>
    ) : (
      sections.map((section, sectionIndex) => (
        <List
          key={section.title ?? sectionIndex}
          dense
          disablePadding
          sx={{ mb: sections.length > 1 ? 2 : 0 }}
        >
          {section.title ? (
            <ListItem disablePadding sx={{ mb: 0.5 }}>
              <ListItemText
                primary={section.title}
                primaryTypographyProps={{
                  variant: 'subtitle2',
                  fontWeight: 600,
                }}
              />
            </ListItem>
          ) : null}
          {section.messages.map((message, index) => (
            <ListItem key={`${section.title}-${index}`} disablePadding>
              <ListItemText
                primary={message}
                primaryTypographyProps={{
                  variant: 'body2',
                  color: 'text.secondary',
                }}
                sx={{ pl: 1.5 }}
              />
            </ListItem>
          ))}
        </List>
      ))
    )}
  </Dialog>
);

export default ErrorDialog;
